const VARIATION_ATTRIBUTE_NAME = 'data-ws-variation-id';
const CATEGORY_ATTRIBUTE_NAME = 'category';

export default {
  VARIATION_ATTRIBUTE_NAME,
  CATEGORY_ATTRIBUTE_NAME,
};
